import React, { useEffect, useRef, useState } from "react";
import styles from "./DropdownMenu.module.css";
import Modal from "react-modal";
import ContactUsPage from "../ContactUs/ContactUs";
import { HashLink } from "react-router-hash-link";
import { dataDropDown } from "../../utils/dataDropdown";
import { useCallback } from "react";

type ModalName = "contactUs";

interface DropdownMenuProps {
  isVisible: boolean;
}

const DropdownMenu: React.FC<DropdownMenuProps> = ({ isVisible }) => {
  const [openModal, setOpenModal] = useState<ModalName | null>(null);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleEscape = (e: KeyboardEvent) => {
      if (e.key === "Escape") {
        setOpenModal(null);
        setIsMenuOpen(false);
      }
    };

    const handleClickOutside = (event: MouseEvent) => {
      if (isMenuOpen && !dropdownRef.current?.contains(event.target as Node)) {
        setIsMenuOpen(false); // Close the menu
      }
    };

    document.addEventListener("keydown", handleEscape);
    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("keydown", handleEscape);
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [openModal, isMenuOpen]);

  const handleLinkClick = useCallback(() => {
    setIsMenuOpen(false);
    window.scrollTo(0, 0); // Scroll to the top of the page
  }, []);

  const handleDropdownMenuClick = () => {
    setIsMenuOpen((prev) => !prev);
  };

  const modalComponents = {
    contactUs: (
      <ContactUsPage
        closeModal={() => setOpenModal(null)}
        isImageFullScreen={false}
        setIsImageFullScreen={() => {}}
      />
    ),
  };

  // const orderedModalNames: ModalName[] = ["contactUs"];
  const orderedModalNames: ModalName[] = [];

  return (
    <div className={styles.dropdownMenu} ref={dropdownRef}>
      <div
        className={`${styles.hamburger} ${
          isVisible ? styles.scrolled : styles.atTop
        }`}
        onClick={handleDropdownMenuClick}
      >
        <div className={styles.line} />
        <div className={styles.line} />
        <div className={styles.line} />
      </div>
      {isMenuOpen && (
        <div className={`${styles.menuItems} ${styles.flexCenter}`}>
          {dataDropDown.map((item, index) => (
            <HashLink
              key={index}
              onClick={handleLinkClick}
              target={item.target}
              to={item.link}
              className={styles.menu}
            >
              {item.name}
            </HashLink>
          ))}
          {orderedModalNames.map((modalName, index) => (
            <div
              key={index}
              className={styles.menu}
              onClick={() => setOpenModal(modalName)}
            >
              {modalName.charAt(0).toUpperCase() +
                modalName.slice(1).replace(/([A-Z])/g, " $1")}
            </div>
          ))}
        </div>
      )}

      {orderedModalNames.map(
        (modalName) =>
          openModal === modalName && (
            <Modal
              key={modalName}
              isOpen={true}
              onRequestClose={() => setOpenModal(null)}
              shouldCloseOnOverlayClick={false}
              className={styles.modal}
              overlayClassName={styles.overlay}
              shouldFocusAfterRender={false}
              shouldReturnFocusAfterClose={false}
              contentLabel={
                modalName.charAt(0).toUpperCase() + modalName.slice(1)
              }
              ariaHideApp={false}
            >
              <div className={styles.innerOverlay}>
                {modalComponents[modalName]}
              </div>
            </Modal>
          ),
      )}
    </div>
  );
};

export default DropdownMenu;
